import {useContext} from 'react'
import {AuthContext} from '../contexts/authContext'

const useAuth = () => {
  const values = useContext(AuthContext)

  return {...values}
}

export default useAuth
